<template>
    <div class="avatar-container" :class="{ 'avatar-container--small': small }">
        <img v-if="src" :src="avatarSrc" :alt="alt" @error="handleError" class="avatar-container__image" />
        <div v-else class="text-[#BD9135]">
            {{ label }}
        </div>
    </div>
</template>

<script>
import { ref } from 'vue'

export default {
    name: 'AvatarContainer',
    props: {
        src: {
            type: String,
            required: false
        },
        alt: {
            type: String,
            default: 'User Avatar'
        },
        small: {
            type: Boolean,
            default: false
        },
        label: {
            type: String,
            default: ''
        }
    },

    setup(props) {
        const avatarSrc = ref(props.src)

        const handleError = () => {
            avatarSrc.value = require('@/assets/student_photo_placeholder.svg')
        }

        return {
            avatarSrc,
            handleError
        }
    }
}
</script>

